import { AxiosError } from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { superAdminService } from "../Service/superAdminService";
import { LoginRequest } from "../Types/Admin/Login";
import { DashboardRoute, UserManagementRoute } from "../utils/Constant";

export const useSuperAdmin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleError = (err: unknown, defaultMessage: string) => {
    if (err instanceof AxiosError) {
      const errorResponse = err.response?.data as {
        message?: string;
        errors?: {
          issues?: Array<{
            code: string;
            expected: string;
            received: string;
            path: string[];
            message: string;
          }>;
          name?: string;
        };
        statusCode?: number;
      };

      if (
        errorResponse?.errors?.name === "ZodError" &&
        errorResponse.errors.issues
      ) {
        const zodErrorMessage = errorResponse.errors.issues
          .map(
            (issue) => `Field ${issue.path.join(".")} error: ${issue.message}`
          )
          .join(", ");

        setError(`Validation Error: ${zodErrorMessage}`);
      } else {
        setError(errorResponse?.message || err.message || defaultMessage);
      }
    } else {
      setError(defaultMessage);
    }
  };

  const login = async (credentials: LoginRequest) => {
    setIsLoading(true);
    try {
      const response = await superAdminService.login(credentials);
      console.log(response);

      localStorage.setItem("adminToken", response.token);
      toast.success("Login successful!");
      navigate(`/${UserManagementRoute}`);
      setError(null);
    } catch (err) {
      handleError(err, "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return { login, error, isLoading };
};
